var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-area position-relative",style:({
    minHeight: _vm.defaultHeight ? _vm.defaultHeight : 'none',
    minWidth: _vm.defaultWidth ? _vm.defaultWidth : 'none',
    maxHeight: _vm.maxHeight ? _vm.maxHeight : 'none',
    maxWidth: _vm.maxWidth ? _vm.maxWidth : 'none',
  })},[_c('span',{staticClass:"area-name"},[_vm._v(" "+_vm._s(_vm.areaName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }